(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  var cache = window.Life100MoreColourCache = window.Life100MoreColourCache || {};
  var requestNumber = 0;

  function cleanFetchedCard(card) {
    var clone = card.cloneNode(true);
    clone.querySelectorAll('[data-cc-animate]').forEach(function(element) {
      element.removeAttribute('data-cc-animate');
      element.classList.remove('cc-animate-init');
      element.classList.remove('cc-animate-complete');
      element.style.removeProperty('opacity');
      element.style.removeProperty('visibility');
    });
    clone.querySelectorAll('img[loading="eager"]').forEach(function(image) {
      image.loading = 'lazy';
    });
    return clone;
  }

  function readOptionValue(option) {
    if (typeof option === 'string') return option;
    return option && typeof option.value === 'string' ? option.value : '';
  }

  function renderColour(root, colour) {
    if (!root || !colour || root.dataset.activeColour === colour) return;

    var grid = root.querySelector('[data-life100-more-colour-grid]');
    if (!grid) return;

    var thisRequest = ++requestNumber;
    root.dataset.activeColour = colour;
    root.hidden = true;

    var collectionUrl = new URL(root.dataset.collectionUrl, window.location.origin);
    collectionUrl.searchParams.set('filter.v.option.color', colour);
    var cacheKey = collectionUrl.pathname + collectionUrl.search;
    var htmlPromise = cache[cacheKey] || fetch(collectionUrl.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(response) {
      if (!response.ok) throw new Error('Colour collection request failed');
      return response.text();
    });
    cache[cacheKey] = htmlPromise;

    htmlPromise.then(function(html) {
      if (thisRequest !== requestNumber || root.dataset.activeColour !== colour) return;

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var currentHandle = root.dataset.productHandle;
      var limit = Number(root.dataset.productLimit) || 8;
      var seenHandles = {};
      var cards = [];

      parsed.querySelectorAll('.product-grid product-block.product-block').forEach(function(card) {
        var handle = card.dataset.productHandle || card.dataset.sezeriumHandle || '';
        if (!handle || handle === currentHandle || seenHandles[handle] || cards.length >= limit) return;
        seenHandles[handle] = true;
        cards.push(cleanFetchedCard(card));
      });

      grid.replaceChildren();
      cards.forEach(function(card) {
        if (root.dataset.carousel === 'true') {
          var item = document.createElement('div');
          item.className = 'slider__item';
          item.appendChild(card);
          grid.appendChild(item);
        } else {
          grid.appendChild(card);
        }
      });

      var link = root.querySelector('[data-life100-more-colour-link]');
      if (link) link.href = collectionUrl.toString();
      root.hidden = cards.length === 0;
      window.dispatchEvent(new Event('resize'));
    }).catch(function() {
      if (thisRequest === requestNumber) root.hidden = true;
    });
  }

  function initialiseColourSection(root) {
    if (!root || root.dataset.life100Initialised === 'true') return;
    root.dataset.life100Initialised = 'true';
    renderColour(root, root.dataset.initialColour);
  }

  document.querySelectorAll('[data-life100-more-colour]').forEach(initialiseColourSection);

  document.addEventListener('on:variant:change', function(event) {
    var detail = event.detail || {};
    var options = detail.selectedOptions || (detail.variant && detail.variant.options) || [];
    document.querySelectorAll('[data-life100-more-colour]').forEach(function(root) {
      var optionIndex = (Number(root.dataset.colourOptionPosition) || 1) - 1;
      renderColour(root, readOptionValue(options[optionIndex]));
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('[data-life100-more-colour]');
    if (root) initialiseColourSection(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-more"]) return;
  try {
    
function loadLife100RelatedProducts(root) {
  if (!root || root.dataset.loaded === 'true') return;
  root.dataset.loaded = 'true';

  fetch(root.dataset.url)
    .then(function(response) { return response.ok ? response.text() : ''; })
    .then(function(html) {
      if (!html) return;
      var container = document.createElement('div');
      container.innerHTML = html;
      var replacement = container.querySelector('[data-life100-related-section="' + root.dataset.life100RelatedSection + '"]');
      if (replacement) root.innerHTML = replacement.innerHTML;
    })
    .catch(function() {});
}

document.querySelectorAll('[data-life100-related-section]').forEach(loadLife100RelatedProducts);
document.addEventListener('shopify:section:load', function(event) {
  var root = event.target.querySelector('[data-life100-related-section]');
  if (root) loadLife100RelatedProducts(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
